export const selectIsLoadingOpportunity = (state) =>
  state?.opportunity?.summary?.isLoading;

export const selectOpportunity = (state) => state?.opportunity?.summary?.data;

export const selectIsOpportunityArchived = (state) =>
  Boolean(state?.opportunity?.summary?.data?.archivedAt);

export const selectOpportunityTitle = (state) =>
  state?.opportunity?.summary?.data?.title;

export const selectOpportunityId = (state) =>
  state?.opportunity?.summary?.data?.id;

export const selectOppType = (state) => state?.opportunity?.summary?.oppType;
